import { render, staticRenderFns } from "./CollectionAccumulativeTotalFollow.vue?vue&type=template&id=3cfe1168&scoped=true&"
import script from "./CollectionAccumulativeTotalFollow.vue?vue&type=script&lang=js&"
export * from "./CollectionAccumulativeTotalFollow.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAccumulativeTotalFollow.vue?vue&type=style&index=0&id=3cfe1168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe1168",
  null
  
)

export default component.exports